import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { AppSettings } from "./config.services";

@Injectable()
export class UsercontrolService {

  constructor(private http: Http) { }

  getUserControl (userControl:string): Observable<string> {
    let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/' + userControl + '.cmp';
    //let serviceUrl = 'http://localhost/admintestsite/' + userControl + '.cmp';
    return this.http.get(serviceUrl)
                    .map(this.extractData)
                    .catch(this.handleError);
  }

  private extractData(res: Response) {
    // let body = res.json();
    // return body.data || { };
    return res.text();
  }
  private handleError (error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    // let errMsg: string;
    // if (error instanceof Response) {
    //   const body = error.json() || '';
    //   const err = body.error || JSON.stringify(body);
    //   errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    // } else {
    //   errMsg = error.message ? error.message : error.toString();
    // }
    // console.error(errMsg);
    // return Observable.throw(errMsg);
    console.error(error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/services/usercontrol.service.ts